var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background-color":"#212121"}},[_c('HeaderBar'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }